import React from "react";
import AppTelephoneFormik from "src/commun/composants/formulaire/formik/fields/AppTelephoneFormik";
import { useFormikContext } from "formik";

type TelephoneFieldProps = {
  name: string;
};
const TelephoneField = ({ name }: TelephoneFieldProps) => {
  const { setFieldValue } = useFormikContext();
  return <AppTelephoneFormik name={name} setFieldValue={setFieldValue} />;
};

export default TelephoneField;
